import React from "react";
import "../assets/styles.css";
import iconA from "../assets/pad-pro-self-help-advocacy.png";

export default function AboutSectionB() {
  const advocacyPoints = [
    "Eliminating occurrences of challenging behavior before antecedents occur.",
    "Reducing occurrence by implementation of intervention plans and reinforcement.",
    "Replacing behaviors with skills and transforming them into productive activities.",
    "Self-help programs focus on the choice need and interest of the individual to acquire responsibility to one's self and develop skills to prepare towards independence."
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white" data-aos="fade-right" data-aos-duration="1000">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Main Content Section */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 sm:gap-8 lg:gap-12 xl:gap-16 mb-12 sm:mb-16 lg:mb-20">
          
          {/* Image */}
          <div className="w-full lg:w-1/3 flex justify-center lg:justify-start order-2 lg:order-1">
            <div className="relative max-w-sm sm:max-w-md lg:max-w-full group">
              <img
                src={iconA}
                alt="Self-Help Advocacy - Group learning session with instructor and participants"
                className="w-full h-auto rounded-lg shadow-lg group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105"
              />
              {/* Enhanced border and overlay effects */}
              <div className="absolute inset-0 rounded-lg border-2 border-transparent group-hover:border-green-300 transition-all duration-300"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-2/3 order-1 lg:order-2">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-black mb-4 sm:mb-6 lg:mb-8 newsreader leading-tight text-center lg:text-left">
              Self-Help Advocacy
            </h2>
            
            <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-black leading-relaxed">
              <p className="text-sm sm:text-base lg:text-lg xl:text-md text-center lg:text-left">
                PADPro's Self-Help Advocacy through Responsive Programming (S.H.A.R.P.) involves a combination of 
                proactive, reactive, and interactive approaches by:
              </p>
              
              {/* Bullet Points - Enhanced responsive design */}
              <ul className="space-y-3 sm:space-y-4">
                {advocacyPoints.map((point, index) => (
                  <li key={index} className="flex items-start gap-3 sm:gap-4">
                    <span className="flex-shrink-0 w-2 h-2 bg-green-600 rounded-full mt-2 sm:mt-2.5"></span>
                    <span className="text-sm sm:text-base lg:text-md text-black leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Additional Information Section - Enhanced layout */}
        <div className="max-w-6xl mx-auto">
          <div>
            <div className="space-y-4 sm:space-y-6 text-black leading-relaxed">
              <p className="text-sm sm:text-base lg:text-md">
                Functional assessment is the key to providing behavior management's effectiveness using the Antecedent Behavior 
                Consequence approach to managing behavior. The curriculum approach is designed to teach an acceptable replacement 
                behavior in the least restrictive environment and provides for positive reinforcement preferences.
              </p>
              
              <p className="text-sm sm:text-base lg:text-md">
                On site activities are structured, and simulation of daily living, work related tasks in age and skills appropriate 
                setting. It provides exercises in self-care (health and hygiene) daily living, food planning and preparation, shopping 
                and money management, decision making, recreation and community integration skills, functional academics, communication 
                and pre-vocational training. Communication tools and materials purchasing complement an individual's program methodology 
                based on his/her interest and capability.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}